<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Daily Bible Text for {{ dateText }}</h4>
            <h6>Manage Daily bible text</h6>
          </div>
        </div>
        <ul class="table-top-head">

          <li>
            <a ref="collapseHeader" data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse"
               @click="toggleCollapse(collapseHeader)">
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn d-flex gap-1">
          <a @click="saveDailyVerse()" href="javascript:void(0);" class="btn btn-added">
            <vue-feather type="plus-circle"
                         class="me-2"></vue-feather>
            Save</a>

          <router-link style="color: var(--PRIMARY-COLOR) !important;" :to="cancelRoute"
                       class="btn btn-added bg-white">
            <vue-feather type="x" class="me-2"></vue-feather>
            Cancel
          </router-link>
        </div>
      </div>


      <div class="card">
        <div class="card-body pb-0">
          <div class="d-flex">
          </div>

          <div class="d-md-flex d-lg-flex justify-content-between gap-2 ">

            <div class="col-md-6 col-lg-6">
              <BFormFloatingLabel> Book</BFormFloatingLabel>
              <!--              <label class="form-label">Book</label>-->
              <a-select
                  v-model:value="dailyVerse.book"
                  class="w-100"
                  placeholder="Select a Book"
                  show-search
                  :options="Books.map(book => ({ label: book.name, value: book.name }))"
                  :filter-option="filterOption"
                  @change="fetchChapters"
              />
            </div>
            <div class="col-md-6 col-lg-6">
              <BFormFloatingLabel> Chapter</BFormFloatingLabel>
              <!--              <input type="number" class="form-control mb-3" v-model="dailyVerse.chapter" :min="1" :max="chapterCount" @change="fetchVerses"/>-->

              <a-select
                  v-model:value="dailyVerse.chapter"
                  class="w-100"
                  placeholder="Select a Chapter"
                  show-search
                  :options="chapterCountArray.map(c => ({ label: c, value: c }))"
                  :filter-option="filterOption"
                  @change="fetchVerses"
                  :disabled="!dailyVerse.book"
              />
            </div>
          </div>

          <div class="d-md-flex d-lg-flex justify-content-between gap-2 ">

            <div class="col-md-6 col-lg-6">
              <BFormFloatingLabel> Verse</BFormFloatingLabel>
              <!--              <input type="number" class="form-control mb-3" v-model="dailyVerse.verse" :min="1" :max="verseCount" />-->
              <a-select
                  v-model:value="dailyVerse.verse"
                  class="w-100"
                  placeholder="Select a Verse"
                  show-search
                  :options="verseCountArray.map(v => ({ label: v, value: v }))"
                  :filter-option="filterOption"
                  :disabled="!dailyVerse.chapter"
              />
            </div>

            <div class="col-md-6 col-lg-6">
              <BFormFloatingLabel> Post Time</BFormFloatingLabel>
              <!--              <BFormInput v-model="dailyVerse.post_time" class="mb-3"/>-->
              <input type="time" class="form-control mb-3" v-model="dailyVerse.post_time"/>
            </div>
          </div>

          <!-- Thumbnail -->
          <div class="card">
            <div class="card-body">
              <h4 class="mb-2">
                Thumbnail
              </h4>

              <div class="d-flex my-2">
                <a-image :width="0" :style="{ display: 'none' }" :preview="{
              visible,
              onVisibleChange: setVisible,
            }" :src="imagePreviewUrl"/>

                <div v-if="imagePreviewUrl" class="image-container col-12 rounded" @mouseover="showOverlay = true"
                     @mouseleave="showOverlay = false">
                  <img :src="imagePreviewUrl" alt="Preview"/>
                  <div v-if="showOverlay" class="overlay">
                    <button @click="deleteImage" class="delete-btn">
                      <vue-feather type="trash-2"></vue-feather>
                    </button>
                    <button @click="openThumbnail(imagePreviewUrl)" class="zoom-btn">
                      <vue-feather type="zoom-in"></vue-feather>
                    </button>
                  </div>
                </div>

                <div class="file-upload " v-else @click="openModal(false)" style="cursor: pointer;">
                  <!--                  <input type="file" @change="previewImage"/>-->

                  <span role="img" aria-label="plus" class="anticon anticon-plus">
                <svg focusable="false" data-icon="plus" width="1em" height="1em" fill="currentColor" aria-hidden="true"
                     viewBox="64 64 896 896">
                  <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path>
                  <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>
                </svg><!----></span>
                  <div class="file-upload-text">Thumbnails</div>
                </div>

              </div>
            </div>
          </div>
          <!-- /Thumbnail -->

          <!-- Curated Images -->
          <div class="card">
            <div class="card-body">
              <h4>
                Curated Images
              </h4>
              <div class="my-2">
                <a-image :width="0" :style="{ display: 'none' }" :preview="{
                  visible,
                  onVisibleChange: setThumbnailVisible,
                }" :src="previewingImage"/>


                <div v-if="thumbnailPreviewUrls.length > 0" class="d-flex gap-3">
                  <div v-for="(image, index) in thumbnailPreviewUrls" :key="index" class="image-container rounded"
                       @mouseover="showOverlay = true" @mouseleave="showOverlay = false">
                    <img :src="image.url" alt="Preview" v-if="image.url"/>
                    <img :src="image" alt="Preview" v-else/>

                    <div v-if="showOverlay" class="overlay">

                      <button @click="deleteThumbnail(image, index)" class="delete-btn">
                        <vue-feather type="trash-2"></vue-feather>
                      </button>
                      <button @click="openThumbnail(image.url)" class="zoom-btn">
                        <vue-feather type="zoom-in"></vue-feather>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="file-upload my-4" @click="openModal(true)" style="cursor:pointer;">
                  <!--                  <input type="file" @change="previewThumbnails" multiple/>-->

                  <span role="img" aria-label="plus" class="anticon anticon-plus"><svg focusable="false"
                                                                                       data-icon="plus" width="1em"
                                                                                       height="1em" fill="currentColor"
                                                                                       aria-hidden="true"
                                                                                       viewBox="64 64 896 896">
                      <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path>
                      <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>
                    </svg><!----></span>
                  <div class="file-upload-text">Curated <br/> Images</div>
                </div>

              </div>
            </div>
          </div>

          <!-- End of curated images -->
          <!--          </div>-->

        </div>
      </div>


    </div>
  </div>

  <MediaModal
      ref="mediaModal"
      :media="media"
      :select-multiple="selectMultiple"
      :selected-media="selectedMedia"
      @selected="handleMediaSelected"
  />

</template>

<script setup>
import {onMounted, computed, reactive, ref, nextTick} from "vue";
import {toggleCollapse} from "@/utils/components";
import axios from "axios";
import {decodeUrlData} from "./utils/data";
import {baseUrl} from "@/constants";
import {useRoute, useRouter} from "vue-router";
import {formatDate} from "@/utils";
import {useDailyVerseStore} from "@/store/dailyVerseStore";
import Swal from "sweetalert2";
import MediaModal from "@/views/pages/modals/mediaModal.vue";
import {useMediaStore} from "@/store/mediaStore";

const route = useRoute();
const router = useRouter();

const dailyVerseStore = useDailyVerseStore();
const mediaStore = useMediaStore();
const media = computed(() => mediaStore.media);

const cancelRoute = {name: "verse-list"};
const action = ref(null);

const visible = ref(false);
const previewingImage = ref("");
const hoverIndex = ref(null);
const selectedFiles = ref([]);
const Books = ref([]);
const chapterCount = ref(0);
const verseCount = ref(0);
const selectedMedia = ref([]);

const dateText = computed(() => formatDate(dailyVerse.value.date));

const mediaModal = ref(null);
const selectMultiple = ref(false)

const showOverlay = ref(false);
const setVisible = (value) => {
  visible.value = value;
};
const setThumbnailVisible = (value) => {
  visible.value = value;
};

const imagePreviewUrl = ref("");
const thumbnailPreviewUrls = ref([]);

const dailyVerse = ref({
  book: '',
  chapter: '',
  verse: '',
  date: null,
  post_time: '',
  thumbnail: '',
  curated_images: [],
  media_item_id: '',
  curated_media_items: []

})

function previewImage(event) {
  const file = event.target.files[0];
  if (file) {
    dailyVerse.value.thumbnail = file;
    log(file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      imagePreviewUrl.value = reader.result;
    };
  }
}

function deleteImage() {
  imagePreviewUrl.value = "";
  dailyVerse.value.thumbnail = null;
  dailyVerse.value.media_item_id = '';
}

function previewThumbnails(event) {
  const files = Array.from(event.target.files);
  files.forEach((file) => {
    selectedFiles.value.push(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      thumbnailPreviewUrls.value.push(e.target.result);
    };
    reader.readAsDataURL(file);
  });

  dailyVerse.value.curated_images = selectedFiles.value;
}

async function deleteThumbnail(image, index) {
  // if (image.url) {
  //   await dailyVerseStore.deleteCuratedImage(image.id);
  // }
  thumbnailPreviewUrls.value.splice(index, 1);
  // If media item (from database)
  if (image.id) {
    // Remove the media ID from the array
    dailyVerse.value.curated_media_items =
        dailyVerse.value.curated_media_items.filter(id => id !== image.id);
  } else {
    // If it was uploaded file (before saving)
    selectedFiles.value.splice(index, 1);
    dailyVerse.value.curated_images = [...selectedFiles.value];
  }
}

function openThumbnail(image) {
  previewingImage.value = image;
  setThumbnailVisible(true);
}

const chapterCountArray = computed(() => [...Array(chapterCount.value).keys()].map(i => i + 1));
const verseCountArray = computed(() => [...Array(verseCount.value).keys()].map(i => i + 1));

const filterOption = (input, option) => {
  return option.label.toString().toLowerCase().includes(input.toString().toLowerCase());
};
const fetchBooks = async () => {
  const res = await axios.get(`${baseUrl}books`);
  Books.value = Array.isArray(res.data.data) ? res.data.data : [];
};

const fetchChapters = async () => {
  if (!dailyVerse.value.book) return;

  dailyVerse.value.chapter = null;
  dailyVerse.value.verse = null;
  verseCount.value = 0;

  const res = await axios.get(`${baseUrl}books/${dailyVerse.value.book}/chapters`);
  chapterCount.value = res.data.data.count;
};

const fetchVerses = async () => {
  if (!dailyVerse.value.book || !dailyVerse.value.chapter) return;

  dailyVerse.value.verse = null;

  const res = await axios.get(
      `${baseUrl}books/${dailyVerse.value.book}/chapters/${dailyVerse.value.chapter}/verses`
  );
  verseCount.value = res.data.data.count;
};

function saveDailyVerse() {

  switch (action.value) {
    case "add":
      dailyVerseStore.addDailyVerse(dailyVerse.value).then((response) => {
        if (response) {
          router.push({name: "verse-list"});
        }
      });
      break;
    case "edit":
      dailyVerseStore
          .updateDailyVerse(dailyVerse.value.id, dailyVerse.value)
          .then((response) => {
            if (response) {
              router.push({name: "verse-list"});
            }
          });
      break;
  }
}

function loadData(currentDailyVerse, skipDate = false) {

  dailyVerse.value.id = currentDailyVerse.id;
  dailyVerse.value.book = currentDailyVerse.book;
  dailyVerse.value.chapter = currentDailyVerse.chapter;
  dailyVerse.value.verse = currentDailyVerse.verse;

  if (currentDailyVerse.media_item_id) {
    imagePreviewUrl.value = currentDailyVerse?.thumbnail_url;
    dailyVerse.value.media_item_id = currentDailyVerse?.media_item_id;

  } else if (currentDailyVerse?.thumbnail_url) {
    imagePreviewUrl.value = currentDailyVerse?.thumbnail_url;
    dailyVerse.value.thumbnail = currentDailyVerse?.thumbnail_url;
  }

  // Load Curated Images
  if (Array.isArray(currentDailyVerse.curated_media_items) && currentDailyVerse.curated_media_items.length > 0) {

    dailyVerse.value.curated_media_items = currentDailyVerse.curated_media_items.map(item => item.id);

    // Filter out empty URLs
    thumbnailPreviewUrls.value = currentDailyVerse.curated_media_items
        .filter(item => item.url) // only items with url
        .map(item => ({
          id: item.id,
          url: item.url
        }));

  } else if (Array.isArray(currentDailyVerse.curated_images_urls) && currentDailyVerse.curated_images_urls.length > 0) {
    dailyVerse.value.curated_images = currentDailyVerse.curated_images_urls;

    // Also populate preview URLs for display
    thumbnailPreviewUrls.value = currentDailyVerse.curated_images_urls.map(image => image);
  } else {
    dailyVerse.value.curated_images = [];
    thumbnailPreviewUrls.value = [];
  }

  if (!skipDate) {
    dailyVerse.value.post_time = currentDailyVerse?.post_time;
    dailyVerse.value.date = currentDailyVerse?.date;
  }
}

async function initDailyVerse() {

  action.value = route.params["action"];
  if (!route.params["encodedData"]) {
    // throw new Error("encodedData param missing");
    alert("data param not found");
    return;
  }

  const decodedData = decodeUrlData(route.params.encodedData);

  if (!decodedData?.date) {
    alert("data date not found");
    return;
  }

  dailyVerse.value.date = decodedData.date;

  switch (action.value) {
    case "edit":
      let data = {};
      data = await loadDailyVerse(new Date(decodedData.date), decodedData.date);
      // console.log(data);
      loadData(data);
      break;
  }
}

async function loadDailyVerse(date, isoDate) {
  // load the daily Verse
  /** @var {Array} */

  const dailyVerses = dailyVerseStore.loadDailyVersesByMonth(
      date.getFullYear(),
      date.getMonth()
  );

  let currentDailyVerse = null;
  if (dailyVerses?.length > 0) {
    const found = dailyVerses.find(dv => dv.date === isoDate);

    currentDailyVerse = found ? found.verse : null;

  }
  if (!currentDailyVerse) {
    currentDailyVerse = await dailyVerseStore.fetchDailyVerseByDate(isoDate);
  }

  return currentDailyVerse;
}

// Media Item Logic

function handleMediaSelected(selected) {
  if (!selectMultiple.value) {
    imagePreviewUrl.value = selected[0]?.url || '';
    dailyVerse.value.media_item_id = selected[0]?.id || '';
  } else {
    selected.forEach(media => {
      const exists = dailyVerse.value.curated_media_items.includes(media.id);
      if (!exists) {
        dailyVerse.value.curated_media_items.push(media.id);
        thumbnailPreviewUrls.value.push({id: media.id, url: media.url});
      }
    });
  }
}

function openModal(isMultiple) {
  selectMultiple.value = isMultiple;
  let preSelected = [];
  if (!isMultiple) {
    if (imagePreviewUrl.value && dailyVerse.value.media_item_id) {
      preSelected = [{id: dailyVerse.value.media_item_id, url: imagePreviewUrl.value}];
      this.selectedMedia = preSelected;
    }
    $("#mediaModal").modal("show");
  } else if (isMultiple) {
    if (thumbnailPreviewUrls.value.length > 0) {
      preSelected = thumbnailPreviewUrls.value.map((item, idx) => ({
        id: item.id || `temp-${idx}`,
        url: item.url
      }));
      this.selectedMedia = preSelected;
    }
    $("#mediaModal").modal("show");
  }
}

// onMounted(fetchBooks);
onMounted(async () => {
  try {
    fetchBooks();
    await mediaStore.fetchMedia();
    await initDailyVerse();
  } catch (e) {
    log(e);
    Swal.fire("Unable to Parse Token", "", "warning");
    router.back();
  }
});
</script>

<style scoped>

</style>